import BankLookupSectionEmbed from '~/components/sections/BankLookupSectionEmbed.vue';
import BankLookupSectionEmbedV2 from '~/components/sections/BankLookupSectionEmbedV2.vue';
export default {
  name: 'BankLookupIframe',
  components: {
    BankLookupSectionEmbed,
    BankLookupSectionEmbedV2
  },
  layout: 'empty',
  data() {
    return {
      history: [],
      query: '',
      result: null
    };
  },
  beforeCreate() {
    this.$config.reportETL = false;
  },
  methods: {
    onRedirect(link) {
      window.open(link, '_blank');
    }
  }
};